
import {get,post} from '@/utils/request'
import {proxyHeader} from "@/utils/config"

//获取卫星分类以及分类中的个数
export const getSatelliteClass = p => get(proxyHeader+'service/satellite-service/satellite/getTypeList', p);

//添加文件到购物车
export const addToCar = p => post(proxyHeader+'service/order-service/car/addCarForSatellite',p);

//公告列表
export const getNoticeList = p => get(proxyHeader+'service/msg-service/msg-notices/list', p);

//新增公告
export const addNotice = p => post(proxyHeader+'service/msg-service/msg-notices/save', p);

//删除公告
export const deleteNotice = p => post(proxyHeader+'service/msg-service/msg-notices/delete', p);

//编辑公告
export const updateNotice = p => post(proxyHeader+'service/msg-service/msg-notices/update', p);

//系统消息列表
export const getSysNotice = p => get(proxyHeader+'service/msg-service/sysOperateMsg/list', p);

//新增系统消息列表
export const addSysNotice = p => post(proxyHeader+'service/msg-service/sysOperateMsg/save', p);

//删除系统消息列表
export const deleteSysNotice = p => post(proxyHeader+'service/msg-service/sysOperateMsg/delete', p);

//编辑系统消息列表
export const updateSysNotice = p => post(proxyHeader+'service/msg-service/sysOperateMsg/update', p);
